import * as React from 'react'

import { MenuSpacer, ListItem } from './style'

const HeaderMenuSpacer = () => (
  <ListItem>
    <MenuSpacer />
  </ListItem>
)

HeaderMenuSpacer.propTypes = {}
HeaderMenuSpacer.defaultProps = {}

export default HeaderMenuSpacer
